require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./2018-01-27-hello-world.json") })
        }
      }, "path---2018-01-27-hello-world");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---2018-01-27-hello-world!./.cache/json/2018-01-27-hello-world.json
// module id = 409
// module chunks = 231608221292675